import { createAsyncThunk } from "@reduxjs/toolkit"
import { CoreState } from "../state/core.state"
import { coreActions } from "../slices/core.slice"
import { authorizedGet } from "../utils/api"

export const fetchProvisioningMessages = createAsyncThunk<
  void,
  any,
  { state: CoreState }
>(
  "core/fetchProvisioningMessages",
  async (_arg, { getState, dispatch }) => {
    const userToken = getState().userToken
    try {
      const res = await authorizedGet(
        "/api/provisioning-messages",
        userToken
      )
      dispatch(coreActions.setProvisioningMessages(res?.length ? res : []))
    } catch (err) {
      // Provisioning banners are cosmetic — a transient failure of this
      // endpoint must not evict an authenticated user to /401 (it raced
      // fetchUserInfo during boot and clobbered the whole login).
      console.error("[fetchProvisioningMessages] failed:", err)
      dispatch(coreActions.setProvisioningMessages([]))
    }
  }
)
